/** @format */

import React from 'react';
import '../css/Masters.css';

import masters from '../utils/masters';
import Master from './cards/Master';

import underline from '../images/line.png';

const Masters = () => {
	return (
		<section className='Masters' id='masters'>
			<div className='masters-container container padding'>
				<h1>
					MÁSTERS
					{/* <img src={underline} alt='underline' className='masters-underline' /> */}
				</h1>
				<div className='masters-content'>
					{masters.map((master, index) => (
						<Master
							key={index}
							image={master.image}
							imageWebp={master.imageWebp}
							video={master.video}
							url={master.page}
							info={master.description}
							title={master.title}
							countdownTimestampMs={master.startDate}
						/>
					))}
				</div>
			</div>
		</section>
	);
};

export default Masters;
